<template>
  <div>
    <div v-if="bannerList.length > 0">
      <div class="main-event">
        <carousel
          :loop="true"
          :per-page="1"
          :autoplay-timeout="5000"
          :autoplay="true"
          :autoplayHoverPause="true"
          :pagination-padding="2"
          :paginationEnabled="false"
        >
          <template v-for="(item, key) in bannerList">
            <slide v-if="item.thumbnail" :key="key" class="slide">
              <a :href="item.link" target="_blank" v-if="item.etc3 === '0'">
                <img :src="item.thumbnail | base64" alt style="height: auto" />
              </a>
            </slide>
          </template>
        </carousel>
      </div>
    </div>
    <div v-else class="Empty">
      <div class="TextBox">
        배너가 없습니다.
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";

export default {
  data() {
    return {
      bannerList: [],
    };
  },
  created() {
    this.getBanners();
  },
  methods: {
    getBanners() {
      const params = {
        page: 1,
        type: 12,
        count: 10,
      };
      Api.Board.getItems(params).then((response) => {
        this.bannerList = response.body;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color_palette.scss";

.main-event {
  /* height: 100px; */
  position: relative;
  .VueCarousel {
    position: relative;
    .VueCarousel-pagination {
      /* width: fit-content;
      position: absolute;
      right: 0;
      bottom: 0; */
      .VueCarousel-dot-container {
        /* margin-top: 0; */
      }
    }
  }
}
.slide {
  a {
    img {
      width: 100%;
      height: auto;
      /* margin-left: 10px; */
      border-radius: 4px;
    }
  }
}
.Empty {
  padding: 12px;
  border: 1px solid $BlueGray400;
  border-radius: 4px;
  .TextBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    text-align: center;
  }
}
</style>
